class ValueHelper {
  private readonly domParser;
  constructor() {
    this.domParser = new DOMParser();
  }
  checkValueInHtml(html?: string | null): boolean {
    if (html) {
      const doc = this.domParser.parseFromString(html, 'text/html');
      let hasText = false;
      doc.querySelectorAll('p').forEach((item) => {
        if (item.innerText?.trim()) {
          hasText = true;
        }
      });
      return hasText;
    }
    return false;
  }
}

export const valueHelper = new ValueHelper();
